<template>
  <div class="fccGestaoCadastrosTipoEndereco">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :status="status"
            :actions="actions"
            addFilter
            :items="listarGestaoCadastrosTipoEndereco"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            fieldVisibility
            pdf
            csv
            xls
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          >
          </fccTable>
        </div>
      </div>
    </div>
    <fccModal
      centered
      idModal="addFieldGestaoCadastrosTipoEnderecoModal"
      titleModal="Novo Tipo de Contato"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="criarGestaoCadastrosTipoEndereco" autocomplete="off">
        <div class="my-2">
          <div class="row">
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criar.tipo"
                >Tipo de Endereço</fccInput
              >
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
    <fccModal
      centered
      idModal="editFieldGestaoCadastrosTipoEnderecoModal"
      titleModal="Editar Tipo de Contato"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="editarGestaoCadastrosTipoEndereco" autocomplete="off">
        <div class="my-2">
          <div class="row my-2">
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="editar.tipo"
                >Tipo de Endereço</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <label>Ativo</label><br />
              <toggle-button v-model="editar.ativo" />
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Gestão de Cadastros - Tipo de Endereço',
      titlePDF: 'Gestão de Cadastros - Tipo de Endereço',
      itemPorPage: '100',
      baseUrlConcursos: store.state.baseUrlConcursos,
      listagemGestaoCadastrosTipoEndereco: [],
      editar: {
        idtipoendereco: '',
        tipo: '',
        ativo: false
      },
      criar: {
        idtipoendereco: 0,
        tipo: '',
        ativo: false
      },
      fields: [
        { key: 'idtipoendereco', label: 'ID', sortable: true, active: true },
        { key: 'tipo', label: 'Tipo de Endereço', sortable: true, active: true },
        {
          key: 'status',
          label: 'Ativo',
          sortable: false,
          tdClass: 'no-print',
          thClass: 'no-print',
          active: true
        },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editFieldGestaoCadastrosTipoEndereco',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteFieldGestaoCadastrosTipoEndereco',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      status: [
        {
          funcaoButton: 'changeStatusGestaoCadastrosTipoEndereco',
          tooltip: 'Alterar Status',
          campoStatus: 'ativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ]
    }
  },
  methods: {
    changeStatusGestaoCadastrosTipoEndereco: function (action, item) {
      this.editar = item
      this.editarGestaoCadastrosTipoEndereco()
    },
    listandoGestaoCadastrosTipoEndereco: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(this.baseUrlConcursos + 'TipoEndereco/Listar', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.listagemGestaoCadastrosTipoEndereco = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.$root.$emit('bv::show::modal', 'addFieldGestaoCadastrosTipoEnderecoModal')
    },
    editFieldGestaoCadastrosTipoEndereco: function (action, item) {
      this.editar = item
      this.$root.$emit('bv::show::modal', 'editFieldGestaoCadastrosTipoEnderecoModal')
    },
    deleteFieldGestaoCadastrosTipoEndereco: function (action, item) {
      this.callConfirm(this.mensagemExcluir, item.tipo).then(() => {
        axios
          .delete(
            this.baseUrlConcursos + 'TipoEndereco/Excluir/' + item.idtipoendereco,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listandoGestaoCadastrosTipoEndereco()
            this.callToast(this.mensagensUpdate.editado)
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      })
    },
    criarGestaoCadastrosTipoEndereco: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      this.criar.idTipoEndereco = 0
      axios
        .post(
          this.baseUrlConcursos + 'TipoEndereco/Adicionar',
          this.criar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoGestaoCadastrosTipoEndereco()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldGestaoCadastrosTipoEnderecoModal')
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldGestaoCadastrosTipoEnderecoModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editarGestaoCadastrosTipoEndereco: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlConcursos + 'TipoEndereco/Alterar',
          this.editar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoGestaoCadastrosTipoEndereco()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'editFieldGestaoCadastrosTipoEnderecoModal')
          this.callToast(this.mensagensUpdate.editado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'editFieldGestaoCadastrosTipoEnderecoModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.listandoGestaoCadastrosTipoEndereco()
  },
  computed: {
    listarGestaoCadastrosTipoEndereco() {
      return this.listagemGestaoCadastrosTipoEndereco
    }
  }
}
</script>
